import { render, staticRenderFns } from "./MultiFormatSetting.vue?vue&type=template&id=46ca2a99&scoped=true&"
import script from "./MultiFormatSetting.vue?vue&type=script&lang=js&"
export * from "./MultiFormatSetting.vue?vue&type=script&lang=js&"
import style0 from "./MultiFormatSetting.vue?vue&type=style&index=0&id=46ca2a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ca2a99",
  null
  
)

export default component.exports